import React , { useState , useEffect } from 'react'



import { ApiCallGet } from '../../ApiCall/ApiCall';
import "../../styles/AddLawer2Styles.css"

function EstadosGlobal( { setRfc , setEstado}) {

    const [countryArr,setCountryArr] = useState( [] )
    const [stateArr,setStateArr] = useState( [] )
    const [ciudadArr,setCiudadArr] = useState( [] )
    const [isFirst,setIsFirst] = useState( true )


    useEffect(()=> {


      var theEstado =
      {
        country : document.getElementById('country').value ,
        estado : document.getElementById('estado').value ,
        ciudad : document.getElementById('ciudad').value
      
      } 

      console.log( "cambio de ciudad = " , theEstado )

      setEstado( theEstado ) ;

    },[ciudadArr])

    function onStateChange()
    {
        console.log( "On state change")
        ApiCallGet('/cities?state=' + document.getElementById( 'estado').value )
        .then((response) => {

            var arr = []




            for( var i = 0 ; i < response.length ; i++ )
            {

                var obj = {

                    id : response[i].id ,
                    name : response[i].name 

                }

                arr.push( obj )

            }

            setCiudadArr( arr ) 

        })


    }

    useEffect(() =>{

        if ( !isFirst )
        {
            return ;
        }

        setIsFirst( false )  ;

        ApiCallGet('/cities?state=' + document.getElementById( 'estado').value )
        .then((response) => {

            var arr = []




            for( var i = 0 ; i < response.length ; i++ )
            {

                var obj = {

                    id : response[i].id ,
                    name : response[i].name 

                }

                arr.push( obj )

            }

            setCiudadArr( arr ) 


            var theEstado =
            {
              country : document.getElementById('country').value ,
              estado : document.getElementById('estado').value ,
              ciudad : document.getElementById('ciudad').value
            
            } 
            console.log( "Cambio de estado = " , theEstado )

            setEstado( theEstado ) ;


        })
        .catch((err) => {

            console.log( err )

        })

    },[stateArr])

    function onCountryChange()
    {
        console.log( "Se ha detectado cambio de country")

        ApiCallGet('/states?country=' + document.getElementById('country').value )
        .then((response) => {

            var arr = []

            console.log( "regresando de response")

            //return ;



            console.log( "response = " , response )

            for( var i = 0 ; i < response.length ; i++ )
            {

                var obj = {

                    id : response[i].id ,
                    name : response[i].name 

                }

                arr.push( obj )

            }

            setStateArr( arr ) 


        })
        .catch((err)=> {

        })

    }


    useEffect(() => {

        ApiCallGet( "/countries")
        .then((response)=>{

            var arr = []

            console.log( "regresando de response")

            //return ;



            console.log( "response = " , response )

            for( var i = 0 ; i < response.length ; i++ )
            {

                var obj = {

                    id : response[i].id ,
                    name : response[i].name 

                }

                arr.push( obj )

            }

            setCountryArr( arr ) 

        })
        .catch((err) => {
            console.log( err )
        })

    } ,[])

    useEffect(() =>{

        // if ( !isFirst )
        // {
        //     return ;
        // }

        // '142' es el pais mexico
        //document.getElementById('country').value = '142' ;

        //onCountryChange() // Para que seleccione el estado

        var theEstado =
        {
          country : document.getElementById('country').value ,
          estado : document.getElementById('estado').value ,
          ciudad : document.getElementById('ciudad').value
        
        } 

        console.log( "country = " , theEstado )


        setEstado( theEstado ) ;

    } ,[countryArr])
    

    

    function setRfcPrev(val) {

        //console.log( "Rfc = " + val.target.value)
    
        setRfc(val.target.value)
    }
    

  return (
    <>
    <div className='row g-0 mt-4'>

    <div className='col-sm-4 '>
      <div className='border-0'
        style={
          {
            height: '70px',
            marginTop: "50px"
          }
        }>
        <p className={'mt-1 ms-4'}
          style={
            {
              fontSize: '30px',
              fontWeight: 'bold',
              textAlign: "left" ,
              marginBottom : "2px"
            }
          }>Ubicación de su lugar de trabajo</p>
        <p style={
          {
            fontSize: '18px',
            fontWeight: 'lighter',
            textAlign: "left",
            paddingLeft: "25px" ,
            
          }
        }>Selecciona lugar donde proporciona sus servicios</p>
      </div>
    </div>
    <div className='col-sm-8 d-flex flex-column align-items-center'>

        <div className='row mt-4 w-100'>

            <div className='col-sm-4'>
                <label className={"estilo_label derecha"} htmlFor="country">Pais</label>
                <select  className={"form-control  border-0 border-bottom border-start estilo_input derecha"}  
                id="country" title='country'
                onChange={onCountryChange}>
                
                
                {countryArr.map(v => <option key={
                  v.id
                } value={
                  v.id
                }>

                  {v.name}
                </option>
                )}
                </select>

            
                

            </div>
            <div className='col-sm-4'>

            <label className={"estilo_label derecha"} htmlFor="estado">Estado</label>
                <select  className={"form-control  border-0 border-bottom border-start estilo_input derecha"}  
                id="estado" title='estado' onChange={onStateChange}>
                
                
                {stateArr.map(v => <option key={
                  v.id
                } value={
                  v.id
                }>

                  {v.name}
                </option>
                )}
                </select>


            </div>
            <div className='col-sm-4'>

            <label className={"estilo_label derecha"} htmlFor="estado">Ciudad</label>
                <select  className={"form-control  border-0 border-bottom border-start estilo_input derecha"}  
                id="ciudad" title='estado'>
                
                
                {ciudadArr.map(v => <option key={
                  v.id
                } value={
                  v.id
                }>

                  {v.name}
                </option>
                )}
                </select>




            </div>

        </div>


    </div>

    </div>
{/*
    <div className='row align-items-center mt-5 mb-4'>


        <div className='col-6'>
          <div className="form-group">
            <label className={"estilo_label"}
              htmlFor="rfc">RFC</label>
            <input type="text" onChange={(val) => setRfcPrev(val )}
              className={"form-control  border-0 border-bottom border-end estilo_input"}
              id="rfc"
              title='Rfc' />

          </div>
        </div>

        <div className='col-6 text-center'>

          <div className='form-group w-100 ' style={{marginTop:'38px'}}>
            <button type='submit' className='btn btn-primary btn-block rounded-0'
              style={
                {
                  width: '100%',
                  position: 'relative',
                  background: '#fBfBfB',
                  color: '#0171E3',
                  border: '1px solid #',
                  padding: '8px 16px',
                  transition: 'all 0.3s ease',
                  overflow: 'hidden',
                  marginTop: "35px"
                }
              }
              onMouseOver={
                (e) => {
                  e.target.style.border = '1px solid #c0c0c0';
                  e.target.style.color = '#c0c0c0';
                }
              }
              onMouseOut={
                (e) => {
                  e.target.style.border = '1px solid #007bff';
                  e.target.style.color = '#007bff';
                }
              }>Finalizar</button>
          </div >
        </div>

    </div>
      
*/}

    </>

  )
}

export default EstadosGlobal